import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Spin, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ReconciliationOutlined, FileProtectOutlined } from '@ant-design/icons';
import { getPRCategories } from '@app/api/prImportFreeSales.api';

const { Title } = Typography;

interface Category {
  title: string;
  url: string;
  cat_id: number;
  section: string;
  type: string;
}

const iconMapper: Record<string, React.ReactNode> = {
  'Veterinary Drugs and Biological': <ReconciliationOutlined />,
  'Animal Feed': <FileProtectOutlined />,
  'Poultry Breeder Farm/Hatchery': <FileProtectOutlined />,
  Exports: <FileProtectOutlined />,
};

const CategorySections: React.FC = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const data = await getPRCategories();

        const formatted: Category[] = data.product_registrations.flatMap((group: any) =>
          group.pr_categories.map((cat: any) => ({
            title: cat.name,
            url: `/product-registrations`,
            cat_id: cat.id,
            section: group.name,
            type: cat.type,
          })),
        );

        setCategories(formatted);
      } catch (error) {
        console.error('Failed to fetch categories', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const grouped = categories.reduce((acc, item) => {
    if (!acc[item.section]) acc[item.section] = [];
    acc[item.section].push(item);
    return acc;
  }, {} as Record<string, Category[]>);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: 50 }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ padding: '12px' }}>
      <Title level={4} style={{ margin: 0 }}>
        Select Product Registration Category
      </Title>
      <br />
      {Object.keys(grouped).map((section) => (
        <Card
          key={section}
          title={
            <Title level={4} style={{ margin: 0 }}>
              {section}
            </Title>
          }
          bordered={false}
          style={{
            marginBottom: 32,
            borderRadius: 12,
            boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
          }}
          bodyStyle={{ padding: '20px 24px' }}
        >
          <Row gutter={[16, 16]}>
            {grouped[section].map((cat) => (
              <Col xs={24} sm={12} md={8} lg={6} key={cat.cat_id}>
                <Card
                  hoverable
                  style={{
                    borderRadius: 10,
                    textAlign: 'center',
                    height: '100%',
                    borderColor: '#8C1C03',
                  }}
                  onClick={() => {
                    if (cat.cat_id) {
                      localStorage.setItem('selected_category_id', cat.cat_id.toString());
                      localStorage.setItem('selected_category_name', cat.title);
                      localStorage.setItem('selected_category_type', cat.type);
                    }
                    if (cat.section === 'Poultry Breeder Farm/Hatchery') {
                      localStorage.setItem('isPoultry', 'true');
                    } else {
                      localStorage.setItem('isPoultry', 'false');
                    }

                    navigate(`${cat.url}`);
                  }}
                >
                  <div style={{ fontSize: 28, marginBottom: 8, color: '#8C1C03' }}>
                    {iconMapper[cat.section] || <FileProtectOutlined />}
                  </div>
                  <div style={{ fontWeight: 500 }}>{cat.title}</div>
                </Card>
              </Col>
            ))}
          </Row>
        </Card>
      ))}
    </div>
  );
};

export default CategorySections;
